import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/views/client/Services/NewConstructionPage/NewConstructionPage.tsx");
